// extracted by mini-css-extract-plugin
export default {"calendar__container":"matchesPage_calendar__container__73F7T","date__header":"matchesPage_date__header__S-jeI","tournament__header":"matchesPage_tournament__header__aGi+w"};